import { render, staticRenderFns } from "./PlpProductsList.vue?vue&type=template&id=3cb94155&"
import script from "./PlpProductsList.vue?vue&type=script&lang=js&"
export * from "./PlpProductsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports